// Self-hosted Monaco, trimmed: core editor + all editing features, syntax
// highlighting for HTML/JS/JSON, and the JSON language service. The
// TypeScript and HTML language services (IntelliSense workers, ~6 MB) are
// left out; a payload editor only needs highlighting and editing commands.
// Monaco 0.56 reorganised the ESM entry points: `vs/editor/editor.api` is
// now `editor`, `editor.all` is `features/register.all`, and the language
// contributions are `languages/{definitions,features}/<lang>/register`.
import * as monaco from 'monaco-editor/editor';
import 'monaco-editor/features/register.all';
import 'monaco-editor/languages/definitions/html/register';
import 'monaco-editor/languages/definitions/javascript/register';
import 'monaco-editor/languages/definitions/css/register';
import 'monaco-editor/languages/features/json/register';
import { loader } from '@monaco-editor/react';
import editorWorker from 'monaco-editor/editor/editor.worker?worker';
import jsonWorker from 'monaco-editor/languages/features/json/json.worker?worker';

self.MonacoEnvironment = {
  getWorker(_id: string, label: string) {
    if (label === 'json') return new jsonWorker();
    return new editorWorker();
  },
};

loader.config({ monaco: monaco as unknown as Parameters<typeof loader.config>[0]['monaco'] });
// Tests and the console reach the editor through window.monaco.
(window as unknown as { monaco: typeof monaco }).monaco = monaco;
